<template>
  <b-modal id="sso-acknowledgement-modal" ref="ssoAcknowledgementModal" hide-footer hide-header-close :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop" @hidden="onModalHidden">
    <template slot="modal-title">SSO Acknowledgement</template>
    <div class="acknowledge">
      <p class="acknowledge-heading">Acknowledge 21 CFR Part 11</p>
      <p class="acknowledge-content">Enabling Single Sign-On (SSO) requires acknowledgement that the chosen Identity Provider (IdP) will now be responsible for ensuring the instance remains compliant through 21 CFR part 11</p>
      <label>
        <input type="checkbox" v-model="acknowledge" @change="checkAcknowledgement" />
        <span class="checkbox-custom"></span>
        <span class="checkbox-label">I Acknowledge</span>
      </label>
    </div>
    <div class="modal-button-container">
      <button class="modal-button cancel" @click="onCloseModal">Cancel</button>
      <button class="modal-button confirm" id="confirmButton" :class="{ active: acknowledged }" :disabled="!acknowledged || apiCallInProgress" @click="confirm()">Confirm</button>
    </div>
  </b-modal>
</template>
<script>
import toastr from "toastr";
import axios from "axios";

export default {
  name: "sso-acknowledgement-modal-component",
  data() {
    return {
      noCloseOnBackdrop: true,
      acknowledge: false,
      acknowledged: false,
      providerDetails: null,
      apiCallInProgress: false
    };
  },
  methods: {
    show(providerDetails) {
      this.providerDetails = providerDetails;
      this.$refs.ssoAcknowledgementModal.show(providerDetails);
    },
    checkAcknowledgement() {
      this.acknowledged = this.acknowledge;
    },
    onCloseModal() {
      this.$refs.ssoAcknowledgementModal.hide();
    },
    onModalHidden() {
      this.acknowledge = false;
      this.acknowledged = false;
    },
    async confirm() {
      this.apiCallInProgress = true;

      if (this.providerDetails.metaType === "FILE") {
        try {
          await axios.put(this.providerDetails.s3UploadUrl, this.providerDetails.file);
          await this.saveAndUpdate();
        } catch (error) {
          toastr.error(`Error occurred while uploading file because of ${error}`);
          this.apiCallInProgress = false;
        }
      } else {
        await this.saveAndUpdate();
      }
    },

    async saveAndUpdate() {
      let resourceMethod = this.providerDetails.id ? "updateProviderDetails" : "addProviderDetails";

      try {
        await this.$api[resourceMethod](this.providerDetails);
        this.$emit("providerAdded", this.providerDetails);
        this.$refs.ssoAcknowledgementModal.hide();
        toastr.success("Identity Provider added");
        this.apiCallInProgress = false;
      } catch (error) {
        this.$refs.ssoAcknowledgementModal.hide();
        toastr.error("Identity Provider failed to create");
        this.apiCallInProgress = false;
      }
    }
  }
};
</script>
<style lang="scss">
#sso-acknowledgement-modal {
  @media (min-width: 500px) {
    .modal-dialog {
      width: 390.7px;
      vertical-align: middle;
    }

    .modal-header {
      border-bottom: none !important;
    }

    .modal-title {
      font-size: 24px;
      font-family: Roboto-Medium;
      padding-left: 47px;
      margin-bottom: -14px;
    }

    .acknowledge {
      background-color: rgba(224, 224, 224, 0.3);
      padding: 16px;
      border-radius: 4px;
      border: solid 1px #e0e0e0;
      margin-left: 10px;
      margin-right: 10px;
    }

    .acknowledge-heading {
      font-size: 16px;
      font-family: Roboto-Bold;
    }

    .acknowledge-content {
      font-family: Roboto-Regular;
      line-height: normal;
      font-size: 14px;
      margin-top: -7px;
    }

    input[type="checkbox"] {
      margin-right: 7px;
      margin-left: 3px;
      display: inline-block;
      width: 18px;
      height: 18px;
      background-color: #fff;
      border: 2px solid #4c8ce4;
      border-radius: 2px;
      margin-right: 10px;
      vertical-align: middle;
      cursor: pointer;
    }

    .checkbox-label {
      color: #64748b;
      font-family: Roboto-Medium;
      vertical-align: middle;
    }

    .label {
      display: block;
    }

    .modal {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .modal-button-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 20px;
      padding-bottom: 10px;
    }

    .modal-button {
      margin: 0 10px;
      width: 97px;
      height: 40px;
      border-radius: 4px;
      font-family: Roboto-Medium;
    }

    .cancel {
      color: #666669;
      border: solid 1px #4c8ce4;
      font-size: 16px;
      background-color: #fff !important;
      font-family: Roboto-Medium;
      font-size: 14px !important;
      cursor: pointer;
    }

    .confirm {
      background-color: #4c8ce4;
      cursor: pointer;
      font-family: Roboto-Medium;
      font-size: 14px !important;
      color: #fff !important;
      border: solid 1px #4c8ce4;
    }

    #confirmButton:disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>
